import React from 'react';
import { Button, Icon } from 'b3';
import { connect } from 'react-redux';
import moment from 'moment';
import UserAvatar from '../../UserAvatar';
import ContactCard from '../../contact-card/ContactCard';
import ConfirmDeleteScheduleModal from '../../schedule/ConfirmDeleteModal';
import { openWizardToCompleteScheduledCall, openWizardToUpdateCall } from '../../schedule-wizard/logActivityReducer';
import TimelineItem from './TimelineItem';
import UnCompletedActivityHeader from './UnCompletedActivityHeader';
import CompletedActivityHeader from './CompletedActivityHeader';
import NoteBubbleWithAvatar from './NoteBubbleWithAvatar';

@connect(
    (state, props) => ({
    	contacts: state.activeClient.contacts,
    }),
    { openWizardToCompleteScheduledCall, openWizardToUpdateCall }
)
export default class PhonecallTimelineItem extends React.Component {
	confirmDelete(e){
	    e.preventDefault();
	    this.props.openModal(ConfirmDeleteScheduleModal, {scheduleId: this.props.id, type: this.props.type});
	}
	editSchedule() {

	    var { id, startDate, description, assignedUser, participatingContact, notes, clientId, createdAt } = this.props;
	    var participatingContactId = participatingContact ? participatingContact.id : null;

	    var callData = {
	    	clientId,
	        id,
	        description,
	        notes,
	        date: moment(startDate),
	        participatingContactId,
	        assignedEmployeeIds: [assignedUser.id],
	        createdAt
	    };

	    this.props.openWizardToUpdateCall(callData);
	}
	openWizardToCompleteScheduledCall(fromAction) {
	    var { id, description, contactId, clientId, notes } = this.props;
	    var participatingContactId = contactId ? contactId : null;

	    var callData = {
	    	clientId,
	        id,
	        description,
	        notes,
	        date: moment(),
	        participatingContactId
	    };

	    this.props.openWizardToCompleteScheduledCall(callData, fromAction);
	}
	completeWizard = () => {
	    this.openWizardToCompleteScheduledCall('COMPLETE');
	}
	noAnswerWizard = (e) => {
		this.openWizardToCompleteScheduledCall('NO_ANSWER');
	}
	leftMessageWizard = (e) => {
		this.openWizardToCompleteScheduledCall('LEFT_MESSAGE');
	}
	render() {
		var { assignedUser, leftMessage, description, contact, notes, completedAt, eventType, isNoAnswer, client } = this.props;
		var icon = <Icon icon="call-1" filled/>
		var avatar = <UserAvatar user={assignedUser}/>

		var getTypeData = () => {
			if(isNoAnswer) return 'noshow';
			if(leftMessage) return 'leftmessage';
			return eventType;
		};

		var getTypeLabel = () => {
			if(isNoAnswer) return 'No Answer';
			if(leftMessage) return "Left Message";
			return "Phone Call";
		};

		var timelineType = getTypeData();
		var typeLabel = getTypeLabel();

		if(completedAt) {
			var isLongContent = notes ? notes.length > 230 : false;

			return (
				<TimelineItem
					type={timelineType}
					typeLabel={typeLabel}
					icon={icon}
					isEditable={true}
					isDeletable={true}
					openEditModal={this.editSchedule.bind(this)}
					openDeleteModal={this.confirmDelete.bind(this)}
					isLongContent={isLongContent}
					wrapInBubble={false}
					isCompleted={true}
				>
					<div>
						<CompletedActivityHeader
							client={client}
							scheduleName="Phone Call"
							avatar={avatar} 
							assignedUser={assignedUser} />
						<div className="scheduled-with-header"><strong>Agenda</strong></div>
						<p>{description}</p>
						<NoteBubbleWithAvatar 
							contact={contact}
							assignedUser={assignedUser}
							notes={notes} 
							avatar={avatar} />
					</div>
				</TimelineItem>
			);
		}

		var isLongContent = description ? (description.length > 230) : false;

		var { tags, clientScore, numberOfStaff, participatingContact, date } =  this.props;

		return (
			<TimelineItem
				date={date}
				type={timelineType}
				typeLabel={typeLabel}
				avatar={null}
				icon={icon}
				isEditable={true}
				isDeletable={true}
				openEditModal={this.editSchedule.bind(this)}
				openDeleteModal={this.confirmDelete.bind(this)}
				wrapInBubble={false}
				isLongContent={isLongContent}
			>
				<div>
					<UnCompletedActivityHeader
						date={date}
						score={clientScore}
						scheduleName="Phone Call"
						tags={tags} 
						client={client}
						avatar={avatar} 
						numberOfStaff={numberOfStaff}
						assignedUser={assignedUser} />

					<div style={{display: 'flex'}}>
						<strong style={{marginRight: 15}}>Agenda</strong>
						<p style={{flex: 1}}>{description}</p>
					</div>
					
					{participatingContact && 
						<div style={{display: 'flex', marginTop: 15, marginBottom: 30}}>
							<strong style={{marginRight: 15}}>Contact</strong>
							<div style={{flex: 1}}>
								<ContactCard contact={participatingContact} />
							</div>
						</div>
					}
					<div className="schedule-actions">
						<Button type="danger" onClick={this.noAnswerWizard}>
						   No Answer
						</Button>
						<Button type="warning" onClick={this.leftMessageWizard}>
						    Left message
						</Button>
						<Button type="success" onClick={this.completeWizard}>
						    Answered
						</Button>
					</div>
				</div>
			</TimelineItem>
		);
	}
}





// WEBPACK FOOTER //
// ./app/components/client-timeline/items/PhonecallTimelineItem.js